import { Component, Input, ViewChild } from '@angular/core';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { FORM_MASK } from '../../../constants/form-masks.const';
import { FormControl, FormGroup } from '@angular/forms';
import { ValidationService } from '../validation.service';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent {
  @ViewChild(ErrorMessageComponent) error;

  public MASK = FORM_MASK;

  @Input() formGroup: FormGroup;
  @Input() fieldName: string;

  @Input() disableRequiredIdentifier: boolean = false;

  public brand;

  constructor() {
    this.brand = environment.brand;
  }

  public get control() {
    return this.formGroup.get(this.fieldName) as FormControl;
  }

  public validation() {
    return ValidationService.getValidationClass(
      this.formGroup.get(this.fieldName) as FormControl, this.brand, this.disableRequiredIdentifier
    );
  }
}
